<template>
  <div class="swiper inModal">
    <swiper :options="productSwiperOptions" ref="productSwiper">
      <swiper-slide v-for="img in product.productImages.data" :key="Math.random().toString(36).substr(2, 9)">
        <div class="card big-product-card">
          <img-comp :element="img" size="xl" :alt="product.name"></img-comp>
        </div>
      </swiper-slide>
    </swiper>
    <div v-if="product.productImages.data.length > 1" class="swiper-pagination-wrapper">
      <div class="icon outline product-swiper-prev">
        <icon name="chevron-left" scale="1.25"></icon>
      </div>
      <div class="product-swiper-pagination" slot="pagination"></div>
      <div class="icon outline product-swiper-next">
        <icon name="chevron-right" scale="1.25"></icon>
      </div>
    </div>
  </div>
</template>

<script>
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'productImagesSlider',
    props: {
      product: {
        type: Object
      }
    },
    mixins: [helpers, formatting],
    data () {
      return {
        productSwiperOptions: {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: '.product-swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.product-swiper-next',
            prevEl: '.product-swiper-prev'
          },
          breakpoints: {
            1300: {
              slidesPerView: 1,
              spaceBetween: 0
            },
            713: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          }
        }
      }
    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/slider/productImagesSlider.vue